/* eslint-disable react/jsx-no-useless-fragment */
import clsx from 'clsx'
import styleUtils from 'shared-components/styles/util.module.css'
import AppImage from 'shared-components/ui/AppImage'
import CreditLink from 'shared-components/ui/CreditLink'
import { BasicStyledComponent, DSImage, DSImageProps } from 'shared-definitions/types'
import styles from './ReviewHeroLow.module.css'

interface PostProps {
  image: DSImage
  badges: readonly DSImageProps[]
}

interface ReviewHeroLowProps extends BasicStyledComponent {
  post: PostProps
}

const ReviewHeroLow: React.FC<ReviewHeroLowProps & React.PropsWithChildren> = ({
  post,
  children,
  className,
}) => {
  if (!post.image) {
    return <>{children}</>
  }

  return (
    <div className={clsx(styles.container, className)}>
      <div className={clsx(styles.imageHolder, styleUtils.mobileFull)}>
        <AppImage
          eager
          image={post.image}
          layout="responsive"
          sizes={[{ bp: 'lg', val: 1220 }, { bp: 'sm', val: 'calc(100vw - rem(30))' }, '80vw']}
        />
        <div className={styles.imageUI}>
          {post.image.credits.map((item, index) => (
            <CreditLink key={index} credit={item} />
          ))}
          {post.badges.slice(0, 3).map((item, index) => (
            <AppImage
              key={index}
              sizes={[{ bp: 'sm', val: 100 }, 48]}
              layout="raw"
              image={item}
              imageClassName={styles.badgeImage}
              className={styles.badgeContainer}
            />
          ))}
        </div>
      </div>
      <div>{children}</div>
    </div>
  )
}

export default ReviewHeroLow
